var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloclwise(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 437,
    viewBox: "0 0 420 437",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M317.963 25.6145L312.075 22.6128L312.631 21.4512L318.562 24.4672L317.963 25.6145Z",
    fill: "#9E7E00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M321.728 27.5845C320.783 27.0217 319.787 26.5455 318.806 26.0404L319.405 24.9004C320.393 25.4055 321.389 25.8889 322.341 26.4517L321.728 27.5845Z",
    fill: "#9E7E00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M323.706 28.7033L322.739 28.1621L323.36 27.0293L324.334 27.5777L323.706 28.7033Z",
    fill: "#9E7E00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M325.657 28.2747L325.021 29.3984L325.504 29.6724L326.141 28.5487L325.657 28.2747Z",
    fill: "#9E7E00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M326.808 30.4629L326.324 30.1887L326.966 29.0703L327.45 29.3517L326.808 30.4629Z",
    fill: "#9E7E00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M328.078 31.1842L327.595 30.91L328.244 29.7988L328.735 30.073L328.078 31.1842Z",
    fill: "#9E7E00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M329.348 31.9141C329.197 31.813 329.031 31.7192 328.872 31.6326L329.529 30.5215C329.695 30.6153 329.853 30.7019 330.012 30.8029L329.348 31.9068V31.9141Z",
    fill: "#9E7E00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M332.284 33.7617L331.808 33.4659L332.486 32.3691L332.962 32.665L332.284 33.7617Z",
    fill: "#9E7E00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M335.92 36.0403L335.444 35.7444L336.144 34.6621L336.62 34.958L335.92 36.0403Z",
    fill: "#9E7E00"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M341.421 39.7493L337.806 37.2528L338.52 36.1777L342.157 38.6887L341.421 39.7493Z",
    fill: "#9E7E00"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M346.102 43.0405C345.236 42.355 344.306 41.7489 343.396 41.114L344.14 40.0605C345.049 40.7027 345.987 41.3016 346.86 41.9943L346.095 43.0333L346.102 43.0405Z",
    fill: "#9E7E00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M349.119 45.3271L347.445 44.0572L348.217 43.0254L349.899 44.3025L349.119 45.3271Z",
    fill: "#9E7E00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M351.859 47.4121L351.022 46.7772L351.816 45.7598L352.66 46.3947L351.859 47.4121Z",
    fill: "#9E7E00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M353.816 48.9566L353.008 48.2855L353.809 47.2754L354.624 47.9464L353.816 48.9566Z",
    fill: "#9E7E00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M355.158 50.0753L354.624 49.6279L355.439 48.625L355.973 49.0724L355.158 50.0753Z",
    fill: "#9E7E00"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M357.065 49.9968L356.239 50.9902L356.778 51.4375L357.603 50.444L357.065 49.9968Z",
    fill: "#9E7E00"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M358.376 52.745L357.842 52.2977L358.672 51.3164L359.206 51.7638L358.376 52.745Z",
    fill: "#9E7E00"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M359.985 54.0797L359.451 53.6395L360.288 52.6582L360.829 53.1056L359.985 54.0797Z",
    fill: "#9E7E00"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M361.544 55.473L361.031 55.004L361.883 54.0371L362.395 54.5061L361.544 55.473Z",
    fill: "#9E7E00"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M363.095 56.872L362.575 56.4102L363.434 55.4434L363.953 55.9196L363.095 56.872Z",
    fill: "#9E7E00"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M365.931 59.4548L365.671 59.2167L366.551 58.2715L366.811 58.5096L365.931 59.4548Z",
    fill: "#9E7E00"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M368.081 61.4607L367.836 61.2153L368.723 60.2773L368.976 60.5227L368.081 61.4607Z",
    fill: "#9E7E00"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M370.165 63.5322L369.92 63.2868L370.822 62.3633L371.074 62.6086L370.165 63.5322Z",
    fill: "#9E7E00"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M372.26 65.6017L372.015 65.3564L372.924 64.4473L373.176 64.6926L372.26 65.6017Z",
    fill: "#9E7E00"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M374.345 67.6733L374.1 67.428L375.023 66.5332L375.276 66.7785L374.345 67.6733Z",
    fill: "#9E7E00"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M378.831 72.5372L374.343 67.674L375.274 66.7793L379.783 71.6714L378.831 72.5372Z",
    fill: "#9E7E00"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M381.666 75.6968C380.974 74.8454 380.216 74.0373 379.466 73.2291L380.425 72.3633C381.176 73.1786 381.934 73.9868 382.633 74.8454L381.659 75.6896L381.666 75.6968Z",
    fill: "#9E7E00"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M383.132 77.4287L382.418 76.5845L383.392 75.7402L384.114 76.5916L383.132 77.4287Z",
    fill: "#9E7E00"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M384.489 79.0387L384.136 78.6202L385.117 77.7832L385.478 78.2161L384.489 79.0387Z",
    fill: "#9E7E00"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M385.434 80.1565L385.073 79.7308L386.069 78.9082L386.43 79.3339L385.434 80.1565Z",
    fill: "#9E7E00"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M386.378 81.2743L386.018 80.8486L387.013 80.0332L387.374 80.4589L386.378 81.2743Z",
    fill: "#9E7E00"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M387.303 82.4006C387.188 82.2563 387.08 82.1048 386.957 81.9605L387.96 81.1523C388.083 81.2894 388.191 81.4482 388.306 81.5925L387.303 82.4006Z",
    fill: "#9E7E00"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M389.424 85.1499L389.085 84.7097L390.102 83.916L390.441 84.3561L389.424 85.1499Z",
    fill: "#9E7E00"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M392.043 88.5481L391.704 88.1079L392.736 87.3359L393.075 87.7761L392.043 88.5481Z",
    fill: "#9E7E00"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M395.91 93.9368L393.385 90.3507L394.431 89.5859L396.971 93.2009L395.91 93.9368Z",
    fill: "#9E7E00"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M399.157 98.6575C398.58 97.7123 397.931 96.8176 397.296 95.9085L398.364 95.1797C399.006 96.0888 399.655 96.9907 400.24 97.9432L399.165 98.6575H399.157Z",
    fill: "#9E7E00"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M401.193 101.846L400.061 100.078L401.143 99.3711L402.283 101.153L401.193 101.846Z",
    fill: "#9E7E00"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M403.046 104.753L402.483 103.866L403.58 103.188L404.143 104.075L403.046 104.753Z",
    fill: "#9E7E00"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M404.338 106.876L403.812 105.967L404.916 105.303L405.442 106.212L404.338 106.876Z",
    fill: "#9E7E00"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M405.212 108.39L404.865 107.791L405.969 107.135L406.323 107.741L405.212 108.39Z",
    fill: "#9E7E00"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M406.259 110.201L405.912 109.603L407.023 108.953L407.377 109.559L406.259 110.201Z",
    fill: "#9E7E00"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M407.297 112.013L406.95 111.414L408.076 110.779L408.422 111.378L407.297 112.013Z",
    fill: "#9E7E00"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M408.343 113.824L407.997 113.225L409.13 112.598L409.476 113.204L408.343 113.824Z",
    fill: "#9E7E00"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M409.324 115.672L408.999 115.059L410.132 114.445L410.457 115.066L409.324 115.672Z",
    fill: "#9E7E00"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M410.283 117.526L409.966 116.913L411.106 116.307L411.423 116.927L410.283 117.526Z",
    fill: "#9E7E00"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M412.051 120.93L411.893 120.62L413.04 120.043L413.206 120.353L412.051 120.93Z",
    fill: "#9E7E00"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M413.371 123.558L413.22 123.241L414.381 122.678L414.526 122.995L413.371 123.558Z",
    fill: "#9E7E00"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M414.605 126.227L414.461 125.91L415.623 125.361L415.774 125.679L414.605 126.227Z",
    fill: "#9E7E00"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M415.841 128.896L415.696 128.579L416.872 128.045L417.017 128.362L415.841 128.896Z",
    fill: "#9E7E00"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M417.081 131.566L416.93 131.248L418.113 130.729L418.257 131.046L417.081 131.566Z",
    fill: "#9E7E00"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M220.496 1.30599L218.173 1.29155V0L220.511 0.014445L220.496 1.30599Z",
    fill: "#9E7E00"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M221.99 1.31966L220.828 1.30522L220.842 0.0136719L222.011 0.0352953L221.99 1.31966Z",
    fill: "#9E7E00"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M222.401 0.0192036L222.376 1.31055L222.766 1.31816L222.791 0.0268193L222.401 0.0192036Z",
    fill: "#9E7E00"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M223.536 1.35541L223.334 1.34819L223.37 0.0566406L223.565 0.0638191L223.536 1.35541Z",
    fill: "#9E7E00"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M223.926 0.109298L223.891 1.40039L224.085 1.4058L224.121 0.114704L223.926 0.109298Z",
    fill: "#9E7E00"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M224.447 0.128805L224.412 1.41992L224.607 1.42519L224.642 0.134073L224.447 0.128805Z",
    fill: "#9E7E00"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M225.071 1.40033L224.876 1.39311L224.912 0.101562L225.114 0.108741L225.071 1.40033Z",
    fill: "#9E7E00"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M226.291 1.4433L226.096 1.43608L226.139 0.144531L226.334 0.15171L226.291 1.4433Z",
    fill: "#9E7E00"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M227.725 0.256475L227.67 1.54688L227.865 1.55524L227.92 0.264838L227.725 0.256475Z",
    fill: "#9E7E00"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M230.13 1.61704L228.586 1.53768L228.651 0.246094L230.195 0.325497L230.13 1.61704Z",
    fill: "#9E7E00"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M232.135 1.73146L230.974 1.65932L231.046 0.375L232.215 0.447137L232.135 1.73146Z",
    fill: "#9E7E00"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M232.792 0.467064L232.707 1.75586L233.449 1.80472L233.534 0.515929L232.792 0.467064Z",
    fill: "#9E7E00"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M234.472 0.653422L234.377 1.94141L234.744 1.96855L234.839 0.680566L234.472 0.653422Z",
    fill: "#9E7E00"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M235.541 1.97728L235.173 1.94843L235.274 0.664062L235.642 0.692908L235.541 1.97728Z",
    fill: "#9E7E00"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M236.081 0.775249L235.977 2.0625L236.221 2.08239L236.326 0.795139L236.081 0.775249Z",
    fill: "#9E7E00"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M236.89 2.08529L236.645 2.06362L236.753 0.779297L236.998 0.80092L236.89 2.08529Z",
    fill: "#9E7E00"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M237.557 0.89909L237.442 2.18555L237.687 2.2074L237.802 0.920943L237.557 0.89909Z",
    fill: "#9E7E00"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M238.347 2.21615L238.109 2.19448L238.225 0.910156L238.47 0.93178L238.347 2.21615Z",
    fill: "#9E7E00"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M238.95 0.962577L238.824 2.24805L239.068 2.2719L239.194 0.986433L238.95 0.962577Z",
    fill: "#9E7E00"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M239.711 1.06212L239.586 2.34766L239.83 2.37138L239.955 1.08585L239.711 1.06212Z",
    fill: "#9E7E00"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M241.162 1.19198L241.027 2.47656L241.149 2.48932L241.284 1.20474L241.162 1.19198Z",
    fill: "#9E7E00"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M242.179 2.60541L242.063 2.59096L242.201 1.30664L242.323 1.32109L242.179 2.60541Z",
    fill: "#9E7E00"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M243.211 2.71932L243.089 2.70488L243.233 1.42773L243.356 1.43496L243.211 2.71932Z",
    fill: "#9E7E00"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M244.236 2.84174L244.113 2.82729L244.265 1.54297L244.387 1.55737L244.236 2.84174Z",
    fill: "#9E7E00"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M245.259 2.96478L245.137 2.95034L245.295 1.66602L245.418 1.68764L245.259 2.96478Z",
    fill: "#9E7E00"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7399 332.342C34.6707 333.871 35.652 335.372 36.6261 336.873L35.551 337.58C34.5769 336.065 33.5884 334.557 32.6504 333.02L33.7471 332.342H33.7399Z",
    fill: "#9E7E00"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9428 329.391C32.4046 330.155 32.8592 330.927 33.3354 331.685L32.2387 332.363C31.7552 331.599 31.3007 330.826 30.8389 330.054L31.9428 329.391Z",
    fill: "#9E7E00"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9921 327.805L31.461 328.584L30.3499 329.241L29.8809 328.461L30.9921 327.805Z",
    fill: "#9E7E00"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1031 326.405L28.9844 327.051L29.2115 327.445L30.3303 326.799L30.1031 326.405Z",
    fill: "#9E7E00"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5475 325.293L29.7712 325.69L28.6528 326.325L28.4219 325.935L29.5475 325.293Z",
    fill: "#9E7E00"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9625 324.262L29.179 324.659L28.0606 325.293L27.8369 324.897L28.9625 324.262Z",
    fill: "#9E7E00"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4043 323.179L27.2754 323.807L27.4962 324.204L28.6251 323.577L28.4043 323.179Z",
    fill: "#9E7E00"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0293 320.746L27.2458 321.143L26.1129 321.756L25.8965 321.359L27.0293 320.746Z",
    fill: "#9E7E00"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4061 317.666L25.6153 318.063L24.468 318.662L24.2588 318.258L25.4061 317.666Z",
    fill: "#9E7E00"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9816 312.84C23.5083 313.908 24.0278 314.976 24.569 316.036L23.4218 316.621C22.8806 315.553 22.3611 314.478 21.8271 313.403L22.9888 312.84H22.9816Z",
    fill: "#9E7E00"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9986 308.639C21.3666 309.461 21.7634 310.269 22.1459 311.085L20.9842 311.64C20.6018 310.818 20.1977 310.01 19.8369 309.18L21.0058 308.639H20.9986Z",
    fill: "#9E7E00"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7269 305.832L20.434 307.391L19.2579 307.917L18.5508 306.352L19.7269 305.832Z",
    fill: "#9E7E00"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6163 303.264L18.9554 304.043L17.7721 304.555L17.4258 303.769L18.6163 303.264Z",
    fill: "#9E7E00"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8364 301.395L18.1611 302.188L16.9706 302.686L16.6387 301.892L17.8364 301.395Z",
    fill: "#9E7E00"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2892 300.082L17.5057 300.609L16.3151 301.092L16.0986 300.573L17.2892 300.082Z",
    fill: "#9E7E00"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6529 298.51L16.8621 299.036L15.6644 299.513L15.4551 298.986L16.6529 298.51Z",
    fill: "#9E7E00"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0331 296.928L16.2351 297.447L15.0374 297.923L14.8281 297.397L16.0331 296.928Z",
    fill: "#9E7E00"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4208 295.342L15.6228 295.869L14.4178 296.33L14.2158 295.804L15.4208 295.342Z",
    fill: "#9E7E00"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8212 293.754L15.0232 294.281L13.811 294.728L13.6162 294.201L14.8212 293.754Z",
    fill: "#9E7E00"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2366 292.16L14.4242 292.687L13.212 293.134L13.0244 292.593L14.2366 292.16Z",
    fill: "#9E7E00"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1901 289.223L13.2839 289.49L12.0645 289.908L11.9707 289.641L13.1901 289.223Z",
    fill: "#9E7E00"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4248 286.957L12.5114 287.224L11.292 287.635L11.1982 287.361L12.4248 286.957Z",
    fill: "#9E7E00"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6827 284.684L11.7693 284.951L10.5426 285.347L10.4561 285.08L11.6827 284.684Z",
    fill: "#9E7E00"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9532 282.404L11.0398 282.671L9.81314 283.061L9.72656 282.787L10.9532 282.404Z",
    fill: "#9E7E00"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2098 280.191L8.97168 280.559L9.05179 280.828L10.2899 280.461L10.2098 280.191Z",
    fill: "#9E7E00"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79479 274.943C9.27101 276.668 9.73999 278.399 10.2667 280.11L9.03291 280.478C8.50618 278.753 8.02993 277.014 7.55371 275.282L8.80201 274.943H8.79479Z",
    fill: "#9E7E00"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92306 271.602L8.59409 274.206L7.34583 274.538L6.6748 271.919L7.92306 271.602Z",
    fill: "#9E7E00"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46701 269.812L7.69068 270.686L6.44243 270.996L6.21875 270.116L7.46701 269.812Z",
    fill: "#9E7E00"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0797 268.146L7.18795 268.587L5.93242 268.882L5.82422 268.442L7.0797 268.146Z",
    fill: "#9E7E00"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M6.81212 266.992L6.91314 267.432L5.65762 267.721L5.55664 267.281L6.81212 266.992Z",
    fill: "#9E7E00"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53673 265.83L6.64498 266.27L5.38228 266.559L5.28125 266.111L6.53673 265.83Z",
    fill: "#9E7E00"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29297 264.668L6.38678 265.115L5.12408 265.39L5.03027 264.949L6.29297 264.668Z",
    fill: "#9E7E00"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7002 261.912L5.79396 262.359L4.53126 262.619L4.4375 262.172L5.7002 261.912Z",
    fill: "#9E7E00"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03652 258.492L5.12311 258.932L3.85318 259.178L3.7666 258.73L5.03652 258.492Z",
    fill: "#9E7E00"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09843 253.174L4.69733 256.695L3.43463 256.919L2.82129 253.383L4.09843 253.174Z",
    fill: "#9E7E00"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M3.39922 248.578L3.80328 251.248L2.52613 251.443L2.12207 248.759L3.39922 248.578Z",
    fill: "#9E7E00"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00073 245.525L3.22441 247.221L1.94731 247.387L1.72363 245.684L3.00073 245.525Z",
    fill: "#9E7E00"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66972 242.74L2.76353 243.592L1.48638 243.743L1.39258 242.885L2.66972 242.74Z",
    fill: "#9E7E00"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M2.45429 240.734L2.54805 241.586L1.26373 241.723L1.16992 240.864L2.45429 240.734Z",
    fill: "#9E7E00"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M2.30976 239.32L2.36027 239.883L1.0759 240.013L1.02539 239.443L2.30976 239.32Z",
    fill: "#9E7E00"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M2.15835 237.625L2.20886 238.188L0.924493 238.311L0.874023 237.74L2.15835 237.625Z",
    fill: "#9E7E00"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M2.006 235.938L2.05652 236.5L0.772193 236.609L0.72168 236.039L2.006 235.938Z",
    fill: "#9E7E00"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M1.88296 234.24L1.91902 234.803L0.634701 234.904L0.598633 234.334L1.88296 234.24Z",
    fill: "#9E7E00"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M1.76093 232.545L1.80422 233.108L0.512675 233.194L0.476562 232.632L1.76093 232.545Z",
    fill: "#9E7E00"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65249 230.85L1.68138 231.412L0.39701 231.492L0.368164 230.922L1.65249 230.85Z",
    fill: "#9E7E00"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M1.50155 227.74L1.51595 228.022L0.224406 228.079L0.209961 227.791L1.50155 227.74Z",
    fill: "#9E7E00"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M1.41464 225.352L1.42182 225.633L0.130269 225.676L0.123047 225.388L1.41464 225.352Z",
    fill: "#9E7E00"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34233 222.957L1.34955 223.238L0.0580037 223.274L0.0507812 222.986L1.34233 222.957Z",
    fill: "#9E7E00"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M1.37844 220.52L0.0869141 220.533L0.0898118 220.815L1.38133 220.801L1.37844 220.52Z",
    fill: "#9E7E00"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M1.28432 218.18L1.29155 218.461H0V218.18H1.28432Z",
    fill: "#9E7E00"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M254.979 431.952C256.841 431.635 258.695 431.289 260.543 430.928L260.795 432.19C258.934 432.551 257.065 432.905 255.196 433.222L254.979 431.952Z",
    fill: "#9E7E00"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M251.386 432.537C252.317 432.4 253.247 432.249 254.178 432.09L254.387 433.36C253.449 433.519 252.519 433.67 251.581 433.807L251.386 432.53V432.537Z",
    fill: "#9E7E00"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M249.466 432.827L250.404 432.689L250.599 433.967L249.646 434.104L249.466 432.827Z",
    fill: "#9E7E00"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M247.677 433.078L248.153 433.006L248.326 434.29L247.857 434.355L247.677 433.078Z",
    fill: "#9E7E00"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M246.894 433.193L246.422 433.254L246.587 434.535L247.06 434.474L246.894 433.193Z",
    fill: "#9E7E00"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M245.203 433.396L245.672 433.338L245.831 434.615L245.362 434.68L245.203 433.396Z",
    fill: "#9E7E00"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M243.955 433.548L244.431 433.49L244.583 434.775L244.107 434.825L243.955 433.548Z",
    fill: "#9E7E00"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M241.42 433.904L240.946 433.953L241.08 435.238L241.554 435.188L241.42 433.904Z",
    fill: "#9E7E00"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M237.352 434.232L237.821 434.182L237.936 435.466L237.46 435.516L237.352 434.232Z",
    fill: "#9E7E00"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M231.682 434.652C232.93 434.565 234.185 434.493 235.434 434.385L235.535 435.669C234.279 435.777 233.024 435.85 231.761 435.936L231.682 434.652Z",
    fill: "#9E7E00"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M226.788 434.895C227.734 434.852 228.679 434.823 229.624 434.766L229.689 436.05C228.737 436.108 227.784 436.137 226.832 436.18L226.781 434.888L226.788 434.895Z",
    fill: "#9E7E00"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M223.548 435.005L225.352 434.947L225.388 436.239L223.584 436.289L223.548 435.005Z",
    fill: "#9E7E00"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M221.458 435.077L220.557 435.09L220.575 436.381L221.477 436.368L221.458 435.077Z",
    fill: "#9E7E00"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M219.382 435.049L218.48 435.055L218.488 436.346L219.39 436.341L219.382 435.049Z",
    fill: "#9E7E00"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M216.976 435.041L217.568 435.055V436.34L216.969 436.333L216.976 435.041Z",
    fill: "#9E7E00"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M215.187 434.998L215.786 435.012L215.772 436.304L215.173 436.29L215.187 434.998Z",
    fill: "#9E7E00"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M213.398 434.955L213.997 434.97L213.968 436.261L213.369 436.247L213.398 434.955Z",
    fill: "#9E7E00"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M211.607 434.918L212.206 434.932L212.17 436.217L211.571 436.202L211.607 434.918Z",
    fill: "#9E7E00"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M209.818 434.875L210.417 434.889L210.366 436.174L209.774 436.167L209.818 434.875Z",
    fill: "#9E7E00"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M208.029 434.832L208.628 434.846L208.571 436.138L207.972 436.124L208.029 434.832Z",
    fill: "#9E7E00"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M204.761 434.607L205.057 434.629L204.977 435.913L204.682 435.892L204.761 434.607Z",
    fill: "#9E7E00"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M202.249 434.436L202.545 434.457L202.451 435.742L202.155 435.72L202.249 434.436Z",
    fill: "#9E7E00"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M199.731 434.262L200.034 434.283L199.926 435.568L199.623 435.546L199.731 434.262Z",
    fill: "#9E7E00"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M197.227 434.053L197.523 434.089L197.4 435.373L197.104 435.337L197.227 434.053Z",
    fill: "#9E7E00"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M194.723 433.764L195.019 433.8L194.882 435.077L194.586 435.048L194.723 433.764Z",
    fill: "#9E7E00"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M189.102 433.115L194.723 433.765L194.586 435.049L188.929 434.392L189.102 433.115Z",
    fill: "#9E7E00"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M185.502 432.582C186.433 432.726 187.364 432.899 188.295 433.022L188.122 434.299C187.184 434.177 186.246 434.003 185.308 433.859L185.502 432.582Z",
    fill: "#9E7E00"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M183.584 432.27L184.522 432.421L184.327 433.691L183.382 433.539L183.584 432.27Z",
    fill: "#9E7E00"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M181.808 431.975L182.277 432.054L182.061 433.324L181.592 433.252L181.808 431.975Z",
    fill: "#9E7E00"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M180.566 431.781L181.042 431.853L180.819 433.123L180.35 433.051L180.566 431.781Z",
    fill: "#9E7E00"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M179.333 431.578L179.802 431.65L179.578 432.92L179.109 432.848L179.333 431.578Z",
    fill: "#9E7E00"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M178.099 431.369C178.258 431.405 178.409 431.42 178.568 431.448L178.337 432.718C178.178 432.69 178.02 432.668 177.868 432.639L178.106 431.369H178.099Z",
    fill: "#9E7E00"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M175.199 430.764L175.661 430.857L175.408 432.127L174.939 432.026L175.199 430.764Z",
    fill: "#9E7E00"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M171.598 430.006L172.067 430.107L171.793 431.362L171.324 431.269L171.598 430.006Z",
    fill: "#9E7E00"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M166.064 428.72C167.276 429.023 168.481 429.377 169.715 429.608L169.427 430.863C168.185 430.632 166.973 430.279 165.754 429.968L166.064 428.713V428.72Z",
    fill: "#9E7E00"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M161.323 427.502L164.073 428.209L163.755 429.457L160.984 428.743L161.323 427.502Z",
    fill: "#9E7E00"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M158.199 426.648L159.058 426.908L159.931 427.139L159.585 428.38L158.704 428.149L157.846 427.889L158.199 426.648Z",
    fill: "#9E7E00"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M155.378 425.783L156.237 426.043L155.869 427.284L155.003 427.017L155.378 425.783Z",
    fill: "#9E7E00"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M153.33 425.129L152.95 426.363L153.812 426.628L154.192 425.394L153.33 425.129Z",
    fill: "#9E7E00"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M151.914 424.717L152.477 424.89L152.088 426.124L151.518 425.943L151.914 424.717Z",
    fill: "#9E7E00"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M150.204 424.189L150.767 424.37L150.37 425.589L149.8 425.416L150.204 424.189Z",
    fill: "#9E7E00"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M148.509 423.611L149.072 423.806L148.66 425.033L148.098 424.831L148.509 423.611Z",
    fill: "#9E7E00"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M146.829 423.006L147.385 423.208L146.966 424.427L146.403 424.225L146.829 423.006Z",
    fill: "#9E7E00"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M145.104 422.303L144.67 423.52L145.234 423.721L145.668 422.505L145.104 422.303Z",
    fill: "#9E7E00"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M143.452 421.801L144.015 422.003L143.575 423.215L143.012 423.013L143.452 421.801Z",
    fill: "#9E7E00"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M140.37 420.689L140.644 420.798L140.182 422.003L139.908 421.887L140.37 420.689Z",
    fill: "#9E7E00"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M138.04 419.736L138.314 419.845L137.838 421.042L137.563 420.934L138.04 419.736Z",
    fill: "#9E7E00"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M135.692 418.715L135.203 419.91L135.477 420.022L135.966 418.827L135.692 418.715Z",
    fill: "#9E7E00"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M133.378 417.824L133.652 417.94L133.147 419.13L132.873 419.015L133.378 417.824Z",
    fill: "#9E7E00"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M131.062 416.844L131.329 416.974L130.817 418.157L130.543 418.027L131.062 416.844Z",
    fill: "#9E7E00"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M125.918 414.469L131.055 416.843L130.535 418.026L125.369 415.638L125.918 414.469Z",
    fill: "#9E7E00"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M122.627 412.932C123.471 413.357 124.337 413.732 125.188 414.137L124.633 415.298C123.774 414.894 122.901 414.519 122.057 414.086L122.627 412.932Z",
    fill: "#9E7E00"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M120.895 412.037L121.746 412.477L121.169 413.632L120.317 413.192L120.895 412.037Z",
    fill: "#9E7E00"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M119.301 411.207L119.719 411.431L119.135 412.578L118.709 412.354L119.301 411.207Z",
    fill: "#9E7E00"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M118.182 410.616L117.589 411.764L118.012 411.982L118.605 410.835L118.182 410.616Z",
    fill: "#9E7E00"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M117.078 410.061L117.496 410.277L116.897 411.417L116.472 411.201L117.078 410.061Z",
    fill: "#9E7E00"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M115.967 409.482L116.385 409.706L115.779 410.839L115.354 410.622L115.967 409.482Z",
    fill: "#9E7E00"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M113.354 408.076L113.766 408.307L113.145 409.44L112.727 409.202L113.354 408.076Z",
    fill: "#9E7E00"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M110.17 406.245L109.526 407.365L109.939 407.602L110.583 406.482L110.17 406.245Z",
    fill: "#9E7E00"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M105.266 403.371C106.312 404.063 107.424 404.648 108.499 405.283L107.842 406.394C106.76 405.752 105.641 405.167 104.588 404.467L105.259 403.363L105.266 403.371Z",
    fill: "#9E7E00"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M101.132 400.746L103.527 402.269L102.849 403.365L100.432 401.836L101.132 400.746Z",
    fill: "#9E7E00"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3969 399.014L99.9122 399.973L99.2051 401.056L97.6826 400.082L98.3969 399.014Z",
    fill: "#9E7E00"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M95.967 397.332L96.703 397.844L95.9815 398.912L95.2383 398.4L95.967 397.332Z",
    fill: "#9E7E00"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2237 396.21L93.4844 397.27L94.2239 397.786L94.9633 396.727L94.2237 396.21Z",
    fill: "#9E7E00"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9942 395.262L93.4848 395.601L92.7417 396.654L92.251 396.308L92.9942 395.262Z",
    fill: "#9E7E00"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5281 394.236L92.0115 394.575L91.2611 395.622L90.7705 395.283L91.5281 394.236Z",
    fill: "#9E7E00"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0632 393.197C90.222 393.32 90.3807 393.435 90.5467 393.551L89.789 394.59C89.6231 394.474 89.4644 394.359 89.3057 394.236L90.0705 393.197H90.0632Z",
    fill: "#9E7E00"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6417 392.107L89.118 392.475L88.3459 393.507L87.877 393.146L88.6417 392.107Z",
    fill: "#9E7E00"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2206 391.025L87.6969 391.386L86.9176 392.411L86.4414 392.05L87.2206 391.025Z",
    fill: "#9E7E00"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7992 389.936L86.2754 390.296L85.4889 391.321L85.0127 390.96L85.7992 389.936Z",
    fill: "#9E7E00"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1945 387.945L83.4326 388.126L82.6317 389.136L82.3936 388.948L83.1945 387.945Z",
    fill: "#9E7E00"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2538 386.344L81.4775 386.539L80.6622 387.542L80.4385 387.347L81.2538 386.344Z",
    fill: "#9E7E00"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3116 384.83L78.4824 385.82L78.7093 386.01L79.5384 385.02L79.3116 384.83Z",
    fill: "#9E7E00"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3868 383.117L77.6177 383.305L76.7807 384.286L76.5498 384.091L77.3868 383.117Z",
    fill: "#9E7E00"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4588 381.502L75.6825 381.69L74.8383 382.664L74.6074 382.469L75.4588 381.502Z",
    fill: "#9E7E00"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M393.175 346.312C394.221 344.919 395.202 343.483 396.212 342.076L397.273 342.812C396.256 344.234 395.267 345.677 394.214 347.077L393.175 346.312Z",
    fill: "#9E7E00"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M391.176 348.995C391.71 348.309 392.222 347.602 392.734 346.902L393.773 347.667C393.254 348.367 392.741 349.081 392.208 349.767L391.183 348.988L391.176 348.995Z",
    fill: "#9E7E00"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M390.632 349.797L390.098 350.496L391.124 351.281L391.658 350.581L390.632 349.797Z",
    fill: "#9E7E00"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M389.069 351.737L389.344 351.391L390.361 352.184L390.087 352.531L389.069 351.737Z",
    fill: "#9E7E00"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M388.618 352.247L388.345 352.592L389.357 353.394L389.63 353.049L388.618 352.247Z",
    fill: "#9E7E00"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M387.633 353.542L387.907 353.203L388.917 354.004L388.643 354.35L387.633 353.542Z",
    fill: "#9E7E00"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M387.18 354.019L386.903 354.361L387.908 355.173L388.185 354.83L387.18 354.019Z",
    fill: "#9E7E00"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M385.181 356.558L385.462 356.219L386.451 357.041L386.176 357.381L385.181 356.558Z",
    fill: "#9E7E00"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M383.294 358.931L383.009 359.266L383.992 360.103L384.277 359.768L383.294 358.931Z",
    fill: "#9E7E00"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M379.552 363.088L381.839 360.49L382.813 361.334L380.504 363.946L379.552 363.088Z",
    fill: "#9E7E00"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M376.493 366.407C377.099 365.779 377.676 365.13 378.268 364.48L379.221 365.354C378.629 366.003 378.044 366.652 377.431 367.287L376.493 366.407Z",
    fill: "#9E7E00"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M374.444 368.578L375.584 367.373L376.515 368.261L375.368 369.473L374.444 368.578Z",
    fill: "#9E7E00"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M373.118 369.837L372.537 370.43L373.46 371.333L374.04 370.741L373.118 369.837Z",
    fill: "#9E7E00"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M371.152 371.911L371.744 371.334L372.653 372.243L372.061 372.828L371.152 371.911Z",
    fill: "#9E7E00"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M370.563 372.474L370.173 372.859L371.08 373.779L371.47 373.394L370.563 372.474Z",
    fill: "#9E7E00"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M368.996 374.041L369.386 373.658L370.288 374.582L369.891 374.964L368.996 374.041Z",
    fill: "#9E7E00"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M368.196 374.858L367.799 375.236L368.69 376.172L369.087 375.793L368.196 374.858Z",
    fill: "#9E7E00"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M366.607 376.313L367.004 375.938L367.892 376.875L367.488 377.251L366.607 376.313Z",
    fill: "#9E7E00"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M365.395 377.432L365.799 377.064L366.679 378.01L366.275 378.385L365.395 377.432Z",
    fill: "#9E7E00"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M364.183 378.55L364.587 378.182L365.46 379.127L365.049 379.502L364.183 378.55Z",
    fill: "#9E7E00"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M362.136 380.509L361.931 380.691L362.788 381.657L362.993 381.475L362.136 380.509Z",
    fill: "#9E7E00"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M360.193 382.101L360.395 381.928L361.247 382.895L361.038 383.075L360.193 382.101Z",
    fill: "#9E7E00"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M358.425 383.616L358.634 383.436L359.471 384.417L359.262 384.597L358.425 383.616Z",
    fill: "#9E7E00"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M356.65 385.101L356.86 384.928L357.689 385.916L357.473 386.097L356.65 385.101Z",
    fill: "#9E7E00"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M354.861 386.581L355.071 386.408L355.886 387.404L355.677 387.584L354.861 386.581Z",
    fill: "#9E7E00"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M270.275 406.74L271.726 411.978L276.964 410.492L275.377 405.297L270.275 406.74Z",
    fill: "url(#paint0_linear_2520_4463)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M329.674 378.896L332.776 383.355L337.214 380.202L333.996 375.822L329.674 378.896Z",
    fill: "url(#paint1_linear_2520_4463)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M318.612 386.068L321.405 390.729C322.992 389.849 324.478 388.795 326.023 387.836L323.108 383.254C321.607 384.185 320.164 385.209 318.62 386.068H318.612Z",
    fill: "url(#paint2_linear_2520_4463)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M301.157 395.348L303.466 400.261C305.14 399.547 306.742 398.696 308.358 397.866L305.919 393.01C304.346 393.818 302.788 394.641 301.157 395.34V395.348Z",
    fill: "url(#paint3_linear_2520_4463)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M312.896 389.359L315.53 394.107L320.256 391.394L317.493 386.711L312.896 389.359Z",
    fill: "url(#paint4_linear_2520_4463)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M307.067 392.433L309.542 397.267C311.151 396.43 312.782 395.629 314.384 394.764L311.779 389.994C310.228 390.831 308.64 391.61 307.067 392.426V392.433Z",
    fill: "url(#paint5_linear_2520_4463)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M324.189 382.563L327.141 387.124C328.656 386.121 330.236 385.219 331.693 384.129L328.62 379.648C327.205 380.709 325.661 381.582 324.189 382.563Z",
    fill: "url(#paint6_linear_2520_4463)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M237.928 412.823L238.469 418.227L243.873 417.556L243.188 412.166L237.928 412.823Z",
    fill: "url(#paint7_linear_2520_4463)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M244.466 412.008L245.187 417.39C246.984 417.152 248.795 416.972 250.577 416.611L249.711 411.25C247.98 411.604 246.219 411.777 244.466 412.008Z",
    fill: "url(#paint8_linear_2520_4463)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M218.172 413.812V413.495C188.632 413.444 159.128 406.734 132.59 393.768C135 396.019 137.532 398.133 140.065 400.355C142.626 402.505 145.303 404.511 147.98 406.626C170.391 414.945 194.275 419.166 218.172 419.245L223.62 419.108L223.475 413.675L218.172 413.812Z",
    fill: "url(#paint9_linear_2520_4463)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M257.475 409.866L258.557 415.184L263.867 413.972L262.641 408.676L257.475 409.866Z",
    fill: "url(#paint10_linear_2520_4463)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M250.982 411.019L251.892 416.373L257.253 415.42L256.199 410.088L250.982 411.019Z",
    fill: "url(#paint11_linear_2520_4463)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M224.768 413.646L224.948 419.072C226.766 419.021 228.577 419.014 230.388 418.841L230.064 413.422C228.303 413.595 226.535 413.595 224.768 413.646Z",
    fill: "url(#paint12_linear_2520_4463)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M231.348 413.323L231.708 418.741L237.142 418.33L236.637 412.926L231.348 413.323Z",
    fill: "url(#paint13_linear_2520_4463)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M285.37 401.97L282.859 402.814L284.656 407.945L287.239 407.072L289.772 406.076L287.838 400.996L285.37 401.97Z",
    fill: "url(#paint14_linear_2520_4463)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M289.036 400.528L291.006 405.586L296.078 403.588L293.972 398.58L289.036 400.528Z",
    fill: "url(#paint15_linear_2520_4463)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M295.156 398.069L297.292 403.062L302.256 400.818L299.983 395.883L295.156 398.069Z",
    fill: "url(#paint16_linear_2520_4463)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M263.898 408.385L265.161 413.667C266.929 413.263 268.704 412.873 270.443 412.339L269.036 407.094C267.347 407.613 265.616 407.988 263.898 408.385Z",
    fill: "url(#paint17_linear_2520_4463)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M276.619 404.929L278.235 410.117L283.402 408.371L281.634 403.227L276.619 404.929Z",
    fill: "url(#paint18_linear_2520_4463)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9203 307.074L39.0859 309.549C39.9229 311.158 40.7239 312.789 41.5897 314.391L46.3591 311.786C45.5221 310.235 44.7429 308.647 43.9275 307.074H43.9203Z",
    fill: "url(#paint19_linear_2520_4463)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9948 312.904L42.2471 315.538L44.9601 320.257L49.6357 317.493L46.9948 312.904Z",
    fill: "url(#paint20_linear_2520_4463)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M126.22 390.507C117.569 385.824 109.249 380.542 101.334 374.705C93.4908 368.759 86.0734 362.28 79.1322 355.303L75.041 359.343C93.7939 378.421 116.407 393.696 141.134 403.92C138.493 401.813 135.975 399.526 133.457 397.361C130.961 395.146 128.601 392.758 126.227 390.5L126.22 390.507Z",
    fill: "url(#paint21_linear_2520_4463)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8246 289.043L30.7666 291.013L32.7652 296.078L37.7728 293.971L35.8246 289.043Z",
    fill: "url(#paint22_linear_2520_4463)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M38.287 295.154L33.2939 297.297L35.5379 302.262L40.4733 299.989L38.287 295.154Z",
    fill: "url(#paint23_linear_2520_4463)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2842 318.619L45.623 321.412C46.5033 322.999 47.5568 324.485 48.5164 326.029L53.0982 323.114C52.1674 321.614 51.1429 320.17 50.2842 318.626V318.619Z",
    fill: "url(#paint24_linear_2520_4463)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3816 285.378L33.5374 282.867L28.4072 284.657L29.2803 287.24L30.276 289.78L35.3557 287.839L34.3816 285.378Z",
    fill: "url(#paint25_linear_2520_4463)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5491 345.316L65.4219 348.845L68.9863 352.965L73.0197 349.321L69.5491 345.316Z",
    fill: "url(#paint26_linear_2520_4463)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3442 340.236L61.1016 343.628C62.2127 345.063 63.3384 346.485 64.5506 347.841L68.6994 344.335C67.5161 343.021 66.4193 341.636 65.337 340.236H65.3442Z",
    fill: "url(#paint27_linear_2520_4463)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8946 350.273L69.8828 353.946L73.642 357.886L77.5528 354.112L73.8946 350.273Z",
    fill: "url(#paint28_linear_2520_4463)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2737 335.049L56.9229 338.296L60.278 342.589L64.5423 339.227L61.2737 335.049Z",
    fill: "url(#paint29_linear_2520_4463)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7916 324.195L49.2314 327.146C50.2344 328.662 51.1363 330.242 52.2259 331.699L56.7066 328.626C55.646 327.211 54.7729 325.667 53.7916 324.195Z",
    fill: "url(#paint30_linear_2520_4463)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4562 329.674L52.9971 332.776L56.1502 337.214L60.5228 333.996L57.4562 329.674Z",
    fill: "url(#paint31_linear_2520_4463)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9987 301.164L36.085 303.473C36.7993 305.147 37.6507 306.749 38.4805 308.365L43.3365 305.926C42.5283 304.353 41.7058 302.795 41.0059 301.164H40.9987Z",
    fill: "url(#paint32_linear_2520_4463)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5338 218.18H22.8513C22.9018 188.64 29.6121 159.136 42.5783 132.598C40.327 135.008 38.2129 137.54 35.9906 140.073C33.8404 142.634 31.8345 145.311 29.7204 147.988C21.401 170.399 17.18 194.282 17.1006 218.18L17.2377 223.627L22.6709 223.483L22.5338 218.18Z",
    fill: "url(#paint33_linear_2520_4463)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5303 237.93L18.126 238.471L18.797 243.875L24.187 243.19L23.5303 237.93Z",
    fill: "url(#paint34_linear_2520_4463)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0311 231.355L17.6123 231.716L18.0236 237.149L23.4279 236.644L23.0311 231.355Z",
    fill: "url(#paint35_linear_2520_4463)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7072 224.768L17.2812 224.948C17.3318 226.766 17.339 228.577 17.5121 230.388L22.9309 230.064C22.7577 228.303 22.7577 226.535 22.7072 224.768Z",
    fill: "url(#paint36_linear_2520_4463)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0801 73.8932L82.4074 69.8887L78.4678 73.6479L82.2414 77.5515L86.0801 73.8932Z",
    fill: "url(#paint37_linear_2520_4463)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8471 126.22C50.5299 117.569 55.8116 109.249 61.6489 101.334C67.5944 93.4908 74.0738 86.0734 81.0511 79.1322L77.0105 75.041C57.9329 93.7939 42.6579 116.407 32.4336 141.134C34.5405 138.493 36.8278 135.975 38.9924 133.457C41.2003 130.961 43.5958 128.601 45.8543 126.227L45.8471 126.22Z",
    fill: "url(#paint38_linear_2520_4463)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4877 257.475L21.1699 258.564L22.3822 263.875L27.6783 262.641L26.4877 257.475Z",
    fill: "url(#paint39_linear_2520_4463)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6134 270.283L24.375 271.726L25.8614 276.965L31.0565 275.385L29.6134 270.283Z",
    fill: "url(#paint40_linear_2520_4463)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9672 263.904L22.6855 265.167C23.0896 266.935 23.4792 268.71 24.0132 270.449L29.2588 269.042C28.7393 267.353 28.3641 265.622 27.9672 263.904Z",
    fill: "url(#paint41_linear_2520_4463)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3456 244.473L18.9629 245.194C19.201 246.991 19.3814 248.802 19.7422 250.584L25.1032 249.718C24.7497 247.987 24.5765 246.226 24.3456 244.473Z",
    fill: "url(#paint42_linear_2520_4463)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3347 250.988L19.9736 251.89L20.9333 257.259L26.2655 256.205L25.3347 250.988Z",
    fill: "url(#paint43_linear_2520_4463)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4232 276.617L26.2354 278.241L27.9815 283.4L33.1189 281.639L31.4232 276.617Z",
    fill: "url(#paint44_linear_2520_4463)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M335.049 375.079L338.296 379.43L342.582 376.075L339.219 371.811L335.049 375.079Z",
    fill: "url(#paint45_linear_2520_4463)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M390.506 310.133C385.823 318.784 380.541 327.104 374.704 335.019C368.758 342.862 362.279 350.28 355.302 357.221L359.342 361.312C378.42 342.559 393.695 319.946 403.919 295.219C401.812 297.86 399.525 300.378 397.36 302.896C395.145 305.393 392.757 307.752 390.499 310.126L390.506 310.133Z",
    fill: "url(#paint46_linear_2520_4463)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M340.237 371.009L343.629 375.252C345.064 374.141 346.486 373.015 347.842 371.803L344.336 367.654C343.022 368.838 341.637 369.934 340.237 371.017V371.009Z",
    fill: "url(#paint47_linear_2520_4463)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M419.109 212.732L413.683 212.877L413.82 218.18H413.502C413.452 247.72 406.742 277.224 393.775 303.762C396.027 301.352 398.141 298.82 400.363 296.287C402.513 293.726 404.519 291.049 406.633 288.372C414.953 265.961 419.174 242.078 419.253 218.18L419.116 212.732H419.109Z",
    fill: "url(#paint48_linear_2520_4463)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M350.273 362.459L353.939 366.464L357.886 362.704L354.105 358.801L350.273 362.459Z",
    fill: "url(#paint49_linear_2520_4463)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M345.31 366.803L348.845 370.93L352.965 367.365L349.321 363.332L345.31 366.803Z",
    fill: "url(#paint50_linear_2520_4463)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0381 69.5491L87.5025 65.4219L83.3896 68.9935L87.0335 73.0197L91.0381 69.5491Z",
    fill: "url(#paint51_linear_2520_4463)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M395.348 135.195L400.262 132.886C399.548 131.212 398.696 129.61 397.866 127.994L393.018 130.433C393.826 132.006 394.648 133.564 395.348 135.195Z",
    fill: "url(#paint52_linear_2520_4463)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M401.964 150.983L402.815 153.494L407.938 151.698L407.065 149.115L406.07 146.582L400.997 148.516L401.964 150.983Z",
    fill: "url(#paint53_linear_2520_4463)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M400.522 147.318L405.587 145.348L403.589 140.275L398.581 142.382L400.522 147.318Z",
    fill: "url(#paint54_linear_2520_4463)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M404.93 159.736L410.111 158.112L408.365 152.953L403.228 154.714L404.93 159.736Z",
    fill: "url(#paint55_linear_2520_4463)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M406.742 166.07L411.973 164.627L410.487 159.389L405.292 160.976L406.742 166.07Z",
    fill: "url(#paint56_linear_2520_4463)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M408.386 172.457L413.668 171.194C413.264 169.426 412.874 167.651 412.34 165.912L407.095 167.319C407.614 169.008 407.989 170.739 408.386 172.457Z",
    fill: "url(#paint57_linear_2520_4463)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M398.061 141.199L403.054 139.063L400.81 134.092L395.882 136.372L398.061 141.199Z",
    fill: "url(#paint58_linear_2520_4463)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M386.069 117.74L390.73 114.948C389.85 113.36 388.796 111.874 387.837 110.33L383.255 113.245C384.186 114.746 385.21 116.189 386.069 117.733V117.74Z",
    fill: "url(#paint59_linear_2520_4463)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M413.646 211.586L419.072 211.405C419.021 209.587 419.014 207.776 418.841 205.965L413.422 206.29C413.595 208.05 413.595 209.818 413.646 211.586Z",
    fill: "url(#paint60_linear_2520_4463)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M382.555 112.156L387.115 109.205C386.112 107.69 385.21 106.11 384.12 104.652L379.64 107.726C380.7 109.14 381.573 110.684 382.555 112.156Z",
    fill: "url(#paint61_linear_2520_4463)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M389.352 123.455L394.1 120.822L391.387 116.096L386.711 118.859L389.352 123.455Z",
    fill: "url(#paint62_linear_2520_4463)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M392.434 129.285L397.268 126.81C396.431 125.201 395.63 123.571 394.765 121.969L389.995 124.574C390.832 126.125 391.611 127.712 392.427 129.285H392.434Z",
    fill: "url(#paint63_linear_2520_4463)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M412.002 191.887L417.384 191.165C417.146 189.369 416.966 187.558 416.605 185.775L411.244 186.641C411.598 188.373 411.764 190.133 412.002 191.887Z",
    fill: "url(#paint64_linear_2520_4463)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M409.858 178.877L415.183 177.795L413.964 172.484L408.675 173.711L409.858 178.877Z",
    fill: "url(#paint65_linear_2520_4463)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M378.897 106.679L383.356 103.576L380.196 99.1387L375.823 102.357L378.897 106.679Z",
    fill: "url(#paint66_linear_2520_4463)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M411.021 185.372L416.374 184.463L415.415 179.102L410.09 180.148L411.021 185.372Z",
    fill: "url(#paint67_linear_2520_4463)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M413.322 204.998L418.741 204.644L418.33 199.211L412.918 199.716L413.322 204.998Z",
    fill: "url(#paint68_linear_2520_4463)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M412.816 198.424L418.228 197.883L417.55 192.479L412.167 193.164L412.816 198.424Z",
    fill: "url(#paint69_linear_2520_4463)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M205.957 17.5121L206.282 22.9309C208.042 22.7577 209.81 22.7577 211.578 22.7072L211.397 17.2812C209.579 17.3318 207.768 17.339 205.957 17.5121Z",
    fill: "url(#paint70_linear_2520_4463)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M129.279 43.9203L126.804 39.0859C125.195 39.9229 123.565 40.7239 121.963 41.5897L124.568 46.3591C126.119 45.5221 127.706 44.7429 129.279 43.9275V43.9203Z",
    fill: "url(#paint71_linear_2520_4463)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M140.274 32.7662L142.381 37.7737L147.309 35.8328L145.34 30.7676L140.274 32.7662Z",
    fill: "url(#paint72_linear_2520_4463)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M135.189 41.0055L132.88 36.0918C131.206 36.8061 129.605 37.6575 127.988 38.4873L130.427 43.3433C132 42.5352 133.559 41.7126 135.189 41.0127V41.0055Z",
    fill: "url(#paint73_linear_2520_4463)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M134.091 35.5429L136.364 40.471L141.191 38.2919L139.055 33.2988L134.091 35.5429Z",
    fill: "url(#paint74_linear_2520_4463)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M149.114 29.2871L146.574 30.2828L148.515 35.3553L150.976 34.3884L153.487 33.537L151.69 28.4141L149.114 29.2871Z",
    fill: "url(#paint75_linear_2520_4463)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M159.383 25.8666L160.97 31.0618L166.072 29.6115L164.628 24.373L159.383 25.8666Z",
    fill: "url(#paint76_linear_2520_4463)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M152.953 27.9883L154.714 33.1257L159.736 31.4229L158.112 26.2422L152.953 27.9883Z",
    fill: "url(#paint77_linear_2520_4463)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M106.674 57.4572L103.579 52.998L99.1338 56.1584L102.359 60.531L106.674 57.4572Z",
    fill: "url(#paint78_linear_2520_4463)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M101.305 61.2819L98.0579 56.9238L93.7646 60.2862L97.1271 64.5505L101.305 61.2819Z",
    fill: "url(#paint79_linear_2520_4463)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M112.157 53.7984L109.206 49.2383C107.691 50.2412 106.111 51.1432 104.653 52.2327L107.727 56.7135C109.141 55.6528 110.685 54.7797 112.157 53.7984Z",
    fill: "url(#paint80_linear_2520_4463)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M375.071 101.304L379.422 98.0575L376.067 93.7715L371.803 97.1339L375.071 101.304Z",
    fill: "url(#paint81_linear_2520_4463)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M117.734 50.2842L114.942 45.623C113.355 46.5033 111.868 47.5568 110.324 48.5164L113.239 53.0982C114.74 52.1674 116.183 51.1429 117.727 50.2842H117.734Z",
    fill: "url(#paint82_linear_2520_4463)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M123.449 47.0017L120.816 42.2539L116.097 44.9669L118.853 49.6425L123.449 47.0017Z",
    fill: "url(#paint83_linear_2520_4463)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M361.313 77.0105C342.56 57.9329 319.947 42.6579 295.22 32.4336C297.861 34.5405 300.379 36.8278 302.897 38.9924C305.393 41.2075 307.753 43.5958 310.127 45.8543C318.778 50.5371 327.098 55.8188 335.013 61.6561C342.856 67.6016 350.273 74.081 357.215 81.0583L361.313 77.0177V77.0105Z",
    fill: "url(#paint84_linear_2520_4463)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M288.366 29.7272C265.955 21.4079 242.072 17.1868 218.174 17.1074L212.727 17.2445L212.871 22.6778L218.174 22.5407V22.8581C247.714 22.9086 277.218 29.619 303.756 42.5851C301.346 40.3339 298.814 38.2198 296.281 35.9975C293.72 33.8473 291.043 31.8414 288.366 29.7272Z",
    fill: "url(#paint85_linear_2520_4463)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M362.461 86.0791L366.466 82.4136L362.706 78.4668L358.803 82.2405L362.461 86.0791Z",
    fill: "url(#paint86_linear_2520_4463)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M366.804 91.0442L370.931 87.5087L367.359 83.3887L363.333 87.0325L366.804 91.0442Z",
    fill: "url(#paint87_linear_2520_4463)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1099 65.3423L92.7187 61.0996C91.2828 62.2108 89.8614 63.3364 88.5049 64.5486L92.0116 68.6974C93.3248 67.5141 94.7101 66.4174 96.1099 65.3351V65.3423Z",
    fill: "url(#paint88_linear_2520_4463)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M371.01 96.1167L375.253 92.7255C374.142 91.2896 373.016 89.8682 371.804 88.5117L367.655 92.0184C368.839 93.3316 369.935 94.7169 371.018 96.1167H371.01Z",
    fill: "url(#paint89_linear_2520_4463)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M185.769 19.748L186.634 25.1091C188.366 24.7555 190.127 24.5824 191.88 24.3515L191.159 18.9688C189.362 19.2069 187.551 19.3873 185.769 19.748Z",
    fill: "url(#paint90_linear_2520_4463)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M172.479 22.3893L173.712 27.6783L178.879 26.4949L177.789 21.1699L172.479 22.3893Z",
    fill: "url(#paint91_linear_2520_4463)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M179.095 20.9382L180.148 26.2631L185.365 25.3324L184.463 19.9785L179.095 20.9382Z",
    fill: "url(#paint92_linear_2520_4463)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M165.904 24.0132L167.311 29.2588C169 28.7393 170.731 28.3641 172.449 27.9672L171.186 22.6855C169.418 23.0896 167.643 23.4792 165.904 24.0132Z",
    fill: "url(#paint93_linear_2520_4463)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M199.204 18.0246L199.709 23.4361L204.998 23.0321L204.637 17.6133L199.204 18.0246Z",
    fill: "url(#paint94_linear_2520_4463)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M192.472 18.8033L193.164 24.186L198.424 23.5293L197.883 18.125L192.472 18.8033Z",
    fill: "url(#paint95_linear_2520_4463)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2520_4463",
    x1: 86.599,
    y1: 221.686,
    x2: 522.866,
    y2: 657.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2520_4463",
    x1: 112.815,
    y1: 159.026,
    x2: 512.401,
    y2: 558.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2520_4463",
    x1: 90.3951,
    y1: 155.131,
    x2: 530.139,
    y2: 594.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2520_4463",
    x1: 78.1071,
    y1: 170.059,
    x2: 540.618,
    y2: 632.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2520_4463",
    x1: 77.4726,
    y1: 151.373,
    x2: 541.764,
    y2: 615.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2520_4463",
    x1: 72.7388,
    y1: 155.71,
    x2: 546.394,
    y2: 629.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2520_4463",
    x1: 100.528,
    y1: 156.028,
    x2: 521.829,
    y2: 577.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2520_4463",
    x1: 90.4734,
    y1: 264.841,
    x2: 497.418,
    y2: 671.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2520_4463",
    x1: 88.7984,
    y1: 255.671,
    x2: 505.18,
    y2: 672.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2520_4463",
    x1: 54.6271,
    y1: 280.319,
    x2: 503.622,
    y2: 729.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2520_4463",
    x1: 90.5748,
    y1: 241.905,
    x2: 510.889,
    y2: 662.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2520_4463",
    x1: 88.7279,
    y1: 247.915,
    x2: 509.696,
    y2: 668.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2520_4463",
    x1: 87.4934,
    y1: 276.234,
    x2: 491.114,
    y2: 679.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2520_4463",
    x1: 88.1642,
    y1: 269.823,
    x2: 495.905,
    y2: 677.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2520_4463",
    x1: 84.6308,
    y1: 202.853,
    x2: 529.801,
    y2: 648.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2520_4463",
    x1: 81.2677,
    y1: 190.863,
    x2: 535.333,
    y2: 644.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2520_4463",
    x1: 81.5199,
    y1: 182.358,
    x2: 536.191,
    y2: 637.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2520_4463",
    x1: 88.009,
    y1: 231.29,
    x2: 518.033,
    y2: 661.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2520_4463",
    x1: 87.8486,
    y1: 214.585,
    x2: 523.757,
    y2: 650.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2520_4463",
    x1: -22.4041,
    y1: 245.57,
    x2: 435.524,
    y2: 703.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2520_4463",
    x1: -19.0335,
    y1: 251.566,
    x2: 438.018,
    y2: 708.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2520_4463",
    x1: -43.9125,
    y1: 229.646,
    x2: 780.71,
    y2: 1054.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2520_4463",
    x1: -29.5469,
    y1: 228.715,
    x2: 410.948,
    y2: 669.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2520_4463",
    x1: -28.3183,
    y1: 233.476,
    x2: 425.811,
    y2: 687.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2520_4463",
    x1: -12.3023,
    y1: 260.614,
    x2: 420.314,
    y2: 693.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2520_4463",
    x1: -32.5704,
    y1: 221.847,
    x2: 407.006,
    y2: 661.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2520_4463",
    x1: 18.161,
    y1: 298.041,
    x2: 357.213,
    y2: 637.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2520_4463",
    x1: 12.2965,
    y1: 291.395,
    x2: 367.307,
    y2: 646.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2520_4463",
    x1: 24.8297,
    y1: 305.141,
    x2: 343.472,
    y2: 623.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2520_4463",
    x1: 6.60247,
    y1: 284.649,
    x2: 377.045,
    y2: 655.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2520_4463",
    x1: -6.44994,
    y1: 268.485,
    x2: 408.114,
    y2: 683.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2520_4463",
    x1: -0.0795852,
    y1: 276.569,
    x2: 393.224,
    y2: 669.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2520_4463",
    x1: -25.6502,
    y1: 239.371,
    x2: 432.37,
    y2: 697.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2520_4463",
    x1: -38.1624,
    y1: 110.035,
    x2: 249.949,
    y2: 398.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2520_4463",
    x1: -49.1581,
    y1: 170.581,
    x2: 364.112,
    y2: 583.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2520_4463",
    x1: -49.9746,
    y1: 163.747,
    x2: 352.597,
    y2: 566.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2520_4463",
    x1: -51.8638,
    y1: 155.607,
    x2: 346.985,
    y2: 554.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2520_4463",
    x1: -53.6329,
    y1: -62.2402,
    x2: 270.152,
    y2: 261.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2520_4463",
    x1: 27.123,
    y1: 80.4887,
    x2: 106.947,
    y2: 160.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2520_4463",
    x1: -42.7373,
    y1: 193.495,
    x2: 383.326,
    y2: 619.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2520_4463",
    x1: -36.8768,
    y1: 209.01,
    x2: 390.053,
    y2: 635.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2520_4463",
    x1: -39.432,
    y1: 201.758,
    x2: 384.472,
    y2: 625.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2520_4463",
    x1: -45.9328,
    y1: 179.548,
    x2: 364.485,
    y2: 589.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2520_4463",
    x1: -43.7894,
    y1: 187.196,
    x2: 370.718,
    y2: 601.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2520_4463",
    x1: -35.7238,
    y1: 214.586,
    x2: 404.007,
    y2: 654.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2520_4463",
    x1: 126.377,
    y1: 163.243,
    x2: 502.732,
    y2: 539.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2520_4463",
    x1: 327.746,
    y1: 274.388,
    x2: 407.578,
    y2: 354.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2520_4463",
    x1: 135.963,
    y1: 163.431,
    x2: 496.767,
    y2: 524.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2520_4463",
    x1: 180.429,
    y1: 32.2456,
    x2: 468.549,
    y2: 320.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2520_4463",
    x1: 159.482,
    y1: 168.097,
    x2: 483.289,
    y2: 491.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2520_4463",
    x1: 146.27,
    y1: 164.325,
    x2: 490.76,
    y2: 508.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2520_4463",
    x1: -61.548,
    y1: -79.5942,
    x2: 282.946,
    y2: 264.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2520_4463",
    x1: -5.5138,
    y1: -270.535,
    x2: 452.521,
    y2: 187.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2520_4463",
    x1: 20.2391,
    y1: -234.167,
    x2: 459.823,
    y2: 205.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2520_4463",
    x1: 16.3381,
    y1: -241.926,
    x2: 456.775,
    y2: 198.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2520_4463",
    x1: 23.2831,
    y1: -227.02,
    x2: 462.964,
    y2: 212.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2520_4463",
    x1: 37.4924,
    y1: -208.389,
    x2: 464.394,
    y2: 218.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2520_4463",
    x1: 43.1058,
    y1: -198.073,
    x2: 467.008,
    y2: 225.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2520_4463",
    x1: 1.17135,
    y1: -260.62,
    x2: 455.266,
    y2: 193.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2520_4463",
    x1: 7.07183,
    y1: -265.843,
    x2: 439.697,
    y2: 166.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2520_4463",
    x1: 81.0759,
    y1: -126.387,
    x2: 479.961,
    y2: 272.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_2520_4463",
    x1: 19.6696,
    y1: -255.257,
    x2: 434.214,
    y2: 159.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_2520_4463",
    x1: -11.1258,
    y1: -281.718,
    x2: 445.926,
    y2: 175.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_2520_4463",
    x1: -8.63396,
    y1: -276.607,
    x2: 449.274,
    y2: 181.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_2520_4463",
    x1: 63.3662,
    y1: -162.108,
    x2: 473.786,
    y2: 248.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_2520_4463",
    x1: 44.2082,
    y1: -192.017,
    x2: 470.264,
    y2: 234.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_2520_4463",
    x1: 34.9787,
    y1: -241.652,
    x2: 428.283,
    y2: 151.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_2520_4463",
    x1: 57.1054,
    y1: -173.887,
    x2: 471.555,
    y2: 240.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_2520_4463",
    x1: 75.4041,
    y1: -138.32,
    x2: 477.997,
    y2: 264.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_2520_4463",
    x1: 63.6825,
    y1: -156.048,
    x2: 476.953,
    y2: 257.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_2520_4463",
    x1: -63.1149,
    y1: -251.846,
    x2: 340.492,
    y2: 151.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_2520_4463",
    x1: -119.87,
    y1: -202.841,
    x2: 353.824,
    y2: 270.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_2520_4463",
    x1: -108.362,
    y1: -217.947,
    x2: 345.667,
    y2: 236.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_2520_4463",
    x1: -113.858,
    y1: -205.798,
    x2: 348.679,
    y2: 256.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_2520_4463",
    x1: -109.237,
    y1: -210.063,
    x2: 345.4,
    y2: 244.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_2520_4463",
    x1: -102.646,
    y1: -220.857,
    x2: 342.488,
    y2: 224.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_2520_4463",
    x1: -95.5244,
    y1: -230.606,
    x2: 340.707,
    y2: 205.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_2520_4463",
    x1: -96.4272,
    y1: -223.159,
    x2: 339.478,
    y2: 212.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_2520_4463",
    x1: -84.3177,
    y1: -130.519,
    x2: 315.266,
    y2: 269.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_2520_4463",
    x1: -74.1612,
    y1: -111.014,
    x2: 302.158,
    y2: 265.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_2520_4463",
    x1: -94.2165,
    y1: -149.712,
    x2: 327.121,
    y2: 271.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_2520_4463",
    x1: 51.6416,
    y1: -226.401,
    x2: 422.077,
    y2: 144.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_2520_4463",
    x1: -102.892,
    y1: -167.621,
    x2: 336.844,
    y2: 272.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_2520_4463",
    x1: -115.005,
    y1: -188.899,
    x2: 349.25,
    y2: 275.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_2520_4463",
    x1: -361.435,
    y1: -634.986,
    x2: 463.195,
    y2: 189.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_2520_4463",
    x1: -76.5617,
    y1: -302.248,
    x2: 372.434,
    y2: 146.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_2520_4463",
    x1: 86.2978,
    y1: -194.009,
    x2: 404.924,
    y2: 124.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_2520_4463",
    x1: 72.1137,
    y1: -207.752,
    x2: 411.164,
    y2: 131.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_2520_4463",
    x1: -67.8811,
    y1: -95.3448,
    x2: 292.911,
    y2: 265.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_2520_4463",
    x1: 61.731,
    y1: -217.362,
    x2: 416.699,
    y2: 137.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_2520_4463",
    x1: -77.4532,
    y1: -244.308,
    x2: 338.921,
    y2: 172.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_2520_4463",
    x1: -83.2506,
    y1: -234.574,
    x2: 337.085,
    y2: 185.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_2520_4463",
    x1: -82.0552,
    y1: -241.233,
    x2: 338.898,
    y2: 179.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_2520_4463",
    x1: -90.5738,
    y1: -233.851,
    x2: 339.436,
    y2: 196.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_2520_4463",
    x1: -67.9986,
    y1: -249.646,
    x2: 339.746,
    y2: 158.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_2520_4463",
    x1: -69.4845,
    y1: -243.854,
    x2: 337.452,
    y2: 163.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F7F00",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A18200",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A38400",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A48500",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A48500",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A28300",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9F7F00",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7E00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloclwise);
export default __webpack_public_path__ + "static/media/cloclwise.9a716705df3b6ae764a19a62d98f8a9e.svg";
export { ForwardRef as ReactComponent };